/**
 * Warlock Pact Boons
 * SRD 5.1 Content
 */

export interface PactBoon {
  id: string;
  name: string;
  description: string;
  benefit: string;
}

/**
 * All Warlock Pact Boons from SRD 5.1
 * Warlocks choose their Pact Boon at level 3
 */
export const PACT_BOONS: PactBoon[] = [
  {
    id: 'pact-of-the-chain',
    name: 'Pact of the Chain',
    description:
      'You learn the find familiar spell and can cast it as a ritual. The spell doesn\'t count against your number of spells known.',
    benefit:
      'When you cast the spell, you can choose one of the normal forms for your familiar or one of the following special forms: imp, pseudodragon, quasit, or sprite. Additionally, when you take the Attack action, you can forgo one of your own attacks to allow your familiar to make one attack with its reaction.',
  },
  {
    id: 'pact-of-the-blade',
    name: 'Pact of the Blade',
    description:
      'You can use your action to create a pact weapon in your empty hand. You can choose the form this melee weapon takes each time you create it.',
    benefit:
      'You are proficient with it while you wield it. This weapon counts as magical for the purpose of overcoming resistance and immunity to nonmagical attacks and damage. Your pact weapon disappears if it is more than 5 feet away from you for 1 minute or more, if you use this feature again, if you dismiss it (no action required), or if you die.',
  },
  {
    id: 'pact-of-the-tome',
    name: 'Pact of the Tome',
    description:
      'Your patron gives you a grimoire called a Book of Shadows. When you gain this feature, choose three cantrips from any class\'s spell list.',
    benefit:
      'The cantrips do not need to be from the same spell list, and they don\'t count against your number of cantrips known. While the book is on your person, you can cast those cantrips at will. If you lose your Book of Shadows, you can perform a 1-hour ceremony to receive a replacement from your patron.',
  },
];

/**
 * Get a pact boon by ID
 */
export function getPactBoon(id: string): PactBoon | undefined {
  return PACT_BOONS.find((b) => b.id === id);
}

/**
 * Get all pact boon IDs
 */
export function getPactBoonIds(): string[] {
  return PACT_BOONS.map((b) => b.id);
}
